import { render } from "./AddPostForm.vue?vue&type=template&id=4b5e2941&scoped=true"
import script from "./AddPostForm.vue?vue&type=script&lang=js"
export * from "./AddPostForm.vue?vue&type=script&lang=js"

import "./AddPostForm.vue?vue&type=style&index=0&id=4b5e2941&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b5e2941"]])

export default __exports__